import {InsideDrawerApplication} from '../inside-drawer.application';
import {IDivHostedAppInitParameters, IOpenAppData} from '@sparkware/uc-sdk-core';
import {getInitAppParamsForControlCenter} from './init-params-helper';
import {IAppInitResultReportingDetails} from '../../../analytics-publisher/casinofied-analytics.service';
import {ICasinofiedComponentFactory} from '../../casinofied-app-factory.interfaces';
import {CasinofiedAppSdkLoader} from '../../casinofied-app-sdk-loader';
import {IServiceFactoryExtended} from '../../../../service-factory-extended.interface';
import {IAppCloseParams} from '../casinofied-application.interface';
import {ControlCenterAnalyticsHelper} from './control-center-analytics-helper';

export class ControlCenterFullApplication extends InsideDrawerApplication {
    // private appClosedSubscription: ITopicSubscription | null = null;

    constructor(openAppData: IOpenAppData,
        _componentFactory: ICasinofiedComponentFactory,
        appSdkLoader: CasinofiedAppSdkLoader,
        services: IServiceFactoryExtended,
        private analyticsHelper: ControlCenterAnalyticsHelper
    ) {
        super(openAppData, _componentFactory, appSdkLoader, services, false);
        // In the old implementation of safezone the close internal was not reported by us, if we have to then we have to use this subscription
        // this.appClosedSubscription = this.services.messageBroker.channels.session.topics.appClosed.subscribe((payload) => {
        //     if (this._isCurrentApp(payload.appID)) {
        //         if (payload.closeReason === this._getOnCloseReason()) {
        //             // report full close external (overlay click)
        //         } else {
        //             // report full close internal (X button, links)
        //         }
        //         this.appClosedSubscription.unsubscribe();
        //     }
        // });

        // at this moment we dont have appInitParams so we have to rely on IOpenAppData
        this.analyticsHelper.setCorrelationID(openAppData.correlationID).setSource(openAppData.launchInfo.appSpecificParameters.source).trackAppOpen();
    }
    protected _getInitAppParams(initParams: IDivHostedAppInitParameters): IDivHostedAppInitParameters {
        let result = super._getInitAppParams(initParams);
        result = getInitAppParamsForControlCenter(result, this.services);
        /* save here the correlationId and the source for analytics */
        this.analyticsHelper.setCorrelationID(result.correlationID).setSource(result.applicationContext.launchInfo.appSpecificParameters.source);
        return result;
    }

    close(params: IAppCloseParams) {
        super.close(params);
        if (params.reason === this._getOnCloseReason()) {
            this.analyticsHelper.trackCloseExternal();
        }
    }

    protected onAppInitSuccess(appInitParams: IDivHostedAppInitParameters, appInitResultReportingDetails?: IAppInitResultReportingDetails) {
        super.onAppInitSuccess(appInitParams, appInitResultReportingDetails);
        this.analyticsHelper.trackAppInitSuccess();
    }

    protected onAppInitTimeout(appInitParams: IDivHostedAppInitParameters, appInitResultReportingDetails?: IAppInitResultReportingDetails) {
        super.onAppInitTimeout(appInitParams, appInitResultReportingDetails);
        this.analyticsHelper.trackAppInitFailed();
    }

    protected onAppInitFailed(appInitParams: IDivHostedAppInitParameters, appInitResultReportingDetails?: IAppInitResultReportingDetails) {
        super.onAppInitFailed(appInitParams, appInitResultReportingDetails);
        this.analyticsHelper.trackAppInitFailed();
    }

}
